import { useCallback } from "react";
import type { DashboardModelT } from "../../schema/dashboard";
import { useDuplicateDashboardCallback } from "../api/dashboard";

export const useDashboardDuplicateCallback = () => {
  const duplicateDashboard = useDuplicateDashboardCallback();

  return useCallback(
    (dashboard: DashboardModelT) => duplicateDashboard(dashboard),
    [duplicateDashboard],
  );
};
